import { createContext } from 'react';

// Set by the headless print page (pages/print/PrintDocument). When present,
// SendReportSection hands it the preview's PDF generator so the backend can
// render the exact same PDF the UI downloads/sends.
const PdfCaptureContext = createContext(null);

export default PdfCaptureContext;
